module.exports = __webpack_public_path__ + "img/perfetti-carousel.fc1adf67.png";